import BaseEntity    	from '@/core/misc/BaseEntity';
import Title_ru_RU  	from '@/core/misc/decorators/Title_ru_RU';
import TYPES        	from '@/core/services/Changelogs/types';

class Lead extends BaseEntity {

	static Events = {
		Created: 'lead:created',
		Updated: 'lead:updated',
		Deleted: 'lead:deleted',
	} as const;

	@Title_ru_RU('Контактное лицо', TYPES.STRING)
	public name: string | null;

	@Title_ru_RU('Email', TYPES.STRING)
	public email: string | null;

	@Title_ru_RU('Телефон', TYPES.STRING)
	public phone: string | null;

	@Title_ru_RU('Приоритет', TYPES.STRING)
	public priority: string | null;

	@Title_ru_RU('Источник', TYPES.STRING)
	public source: string | null;

	@Title_ru_RU('Статус', TYPES.STRING)
	public status: string | null;

	/** Произвольная структура от лендингов (actions, метаданные формы и т.д.) */
	public data: any;

	static fromServer(data: any, result = new Lead()): Lead {
		super.fromServer(data, result);

		return result;
	}
}

export default Lead;
